module.exports = __webpack_public_path__ + "img/training-plan-bg.7a1f44f3.png";